import PropTypes from 'prop-types';
import { css } from 'linaria';
const BylineWrapper = "b1yvsvix";

function Authors({
  authors
}) {
  return <ul>
      {authors.map(author => <li key={`author-byline-${author}`} itemProp="author" data-cy="author">
          {author}
        </li>)}
    </ul>;
}
/**
 * `url`, `name`, and `authorNames` are required props for this component.
 * `authorNames` must be passed in as an Array
 *
 * `showAuthors` is a bool that defines whether to display the author list alongside
 * the publisher. This value is set in the curation tool.
 */


function AuthorByline({
  url,
  name,
  showAuthors,
  authorNames
}) {
  return <cite className={BylineWrapper}>
      <a href={url} data-cy="author-url">{name}</a>
      {showAuthors ? <Authors authors={authorNames} /> : null}
    </cite>;
}

AuthorByline.propTypes = {
  /**
   * Url links to the publisher's website
   */
  url: PropTypes.string.isRequired,

  /**
   * Name of the publisher
   */
  name: PropTypes.string.isRequired,

  /**
   * Array of the list of authors
   */
  authorNames: PropTypes.array.isRequired,

  /**
   * Determines whether to show or hide the list of authors
   */
  showAuthors: PropTypes.bool
};
export { AuthorByline };

require("../../../.linaria-cache/src/components/content-author/author-byline.linaria.module.css");